<template>
    <div id="floating-holder">
        <div v-if="whatsapp" class="float-holder highlightOnHover" @click="openWhatsApp" :class="{ 'clicked': clickedWahts }">
            <span class="imoon-whatsapp"></span>
        </div>
    </div>
</template>

<script>
import { data } from 'jquery';
import { method } from 'lodash';

export default {
    name: 'floatingHolder',
    props: {
        whatsapp: {
            type: Boolean,
            default: false, // Default to true to show WhatsApp icon
        },
        whatsUpUri: {
            type: String,
            default: 'https://wa.me/528006110033',
        },
        timeout: {
            type: Number,
            default: 700, // Default timeout of 1 second
        },
    },
    data() {
        return {
            clickedWahts: false,
        };
    },
    methods: {
        openWhatsApp() {
            this.clickedWahts = true;
            setTimeout(() => {
                window.open(this.whatsUpUri, '_blank');
                this.clickedWahts = false;
            }, this.timeout);
        },
    },
}
</script>

<style lang="scss">
@import '@/sass/utils/variables.scss';
$iconSize: 1.75em;

#floating-holder {
    // background-color: yellow;
    position: fixed;
    right: 1em;
    bottom: 1em;
    z-index: 1000;

    .float-holder {
        color: $accent;
        background-color: rgba(0, 0, 0, 0.499);
        font-size: 1.75em;
        width: $iconSize;
        height: $iconSize;
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        cursor: pointer;
        backdrop-filter: blur(4px);


        transition: opacity 0.7s, box-shadow 2s, color 0.3s, background-color 1s;

        span {
            transition: transform 0.7s;
        }

        &.clicked,
        &:active,
        &:hover {
            background-color: $accent;
            transition: opacity 0.3s, box-shadow 0.1s, color 0.1s, background-color 0.7s;
            opacity: 1;
            color: #fff;

            span {
                transform: scale(1.1);
                transition: transform 0.3s;
            }
        }
    }
}
</style>